export enum SkinVoiceType {
  NONE = 0,
  ILLUST = 1,
  ALL = 2,
}

export const CharWordShowType = {
  "0": "HOME_SHOW",
  "1": "HOME_PLACE",
  "2": "HOME_WAIT",
  "3": "GACHA",
  "4": "EVOLVE_ONE",
  "5": "EVOLVE_TWO",
  "6": "FOUR_STAR",
  "7": "THREE_STAR",
  "8": "TWO_STAR",
  "9": "LOSE",
  "10": "LEVEL_UP",
  "11": "SQUAD",
  "12": "SQUAD_FIRST",
  "13": "BATTLE_START",
  "14": "BATTLE_FACE_ENEMY",
  "15": "BATTLE_SELECT",
  "16": "BATTLE_PLACE",
  "17": "BATTLE_SKILL_1",
  "18": "BATTLE_SKILL_2",
  "19": "BATTLE_SKILL_3",
  "20": "BATTLE_SKILL_4",
  "21": "BUILDING_PLACE",
  "22": "BUILDING_DRAGGING",
  "23": "BUILDING_FAVOR_BUBBLE",
  "24": "BUILDING_TOUCHING",
  "25": "LOADING_PANEL",
  "26": "BIRTHDAY",
  "27": "NEW_YEAR",
  "28": "VALENT_DAY",
  "29": "DRAGON_BOAT_FESTIVAL",
  "30": "HALLOWEEN_DAY",
  "31": "CHRISMATS_DAY",
  "32": "GREETING",
  "33": "ANNIVERSARY",
  "34": "UNUSED",
} as const;

export const ILLUST_SHOW_TYPES = new Set([
  "HOME_SHOW",
  "HOME_PLACE",
  "HOME_WAIT",
  "GACHA",
  "EVOLVE_ONE",
  "EVOLVE_TWO",
  "FOUR_STAR",
  "THREE_STAR",
  "TWO_STAR",
  "LOSE",
  "LEVEL_UP",
  "SQUAD",
  "SQUAD_FIRST",
  "BATTLE_START",
  "BUILDING_PLACE",
  "LOADING_PANEL",
  "BIRTHDAY",
  "NEW_YEAR",
  "GREETING",
  "ANNIVERSARY",
]);
